import React from "react";
import {formLayout} from "./constant/css";
import { getLanguage,
    LEGAL_NAME,
    LOGIN,
    USER_ID,
    validateMessages
} from "./source/js/common";
import AisinoForm from "./baseComponent/form/AisinoForm";
import AisinoButton from "./baseComponent/button/AisinoButton";
import AisinoButtonArea from "./common/area/AisinoButtonArea";
import AisinoFormItem from "./baseComponent/form/AisinoFormItem";
import {AisinoPassword} from "./baseComponent/form";
import {aisinoCancelConfirmModal, aisinoConfirmModal, aisinoInfoModal} from "./common/modal/AisinoModalMethod";
import {post, postSync} from "./common/utils/http";
import cookie from "react-cookies";
import store from "./store";
import {logout} from "./store/actions";
import {dropByCacheKey, getCachingKeys} from "react-router-cache-route";
import {Modal} from "antd";
import CheckSquareOutlined from "@ant-design/icons/es/icons/CheckSquareOutlined";
import CloseSquareOutlined from "@ant-design/icons/es/icons/CloseSquareOutlined";
import {pwdCheck} from "./common/utils/StringUtils";

const commonLan = require('./constant/js/formItemNameLabel/'+getLanguage()+'/common.js');
const loginLan = require('./constant/js/formItemNameLabel/'+getLanguage()+'/login.js');
class ModifyPassword extends React.Component{
    state={
        pageFlag:'modify',
        callbackFun:''
    }
    componentDidMount() {
        // const info = this.props.location.state;
        // console.log(this.props)
        // if(!isEmpty(info)){
        //     this.setState({callbackFun:info.callbackFun});
        // }
    }

    close = ()=>{
        if(!this.props.login){
            aisinoCancelConfirmModal(()=>{
                this.refs.modifyPwdForm.setFieldsValue({
                    oldpwd:"",
                    newpwd:"",
                    newpwdagain:"",
                })
                this.props.handleClose()
            })
        }else{
            Modal.confirm({
                title:commonLan.confirmButton.label,
                content: loginLan.modifyPasswordCancel,
                okText:commonLan.okButton.label,
                cancelText:commonLan.cancelButton.label,
                onOk:()=>{
                    this.refs.modifyPwdForm.setFieldsValue({
                        oldpwd:"",
                        newpwd:"",
                        newpwdagain:"",
                    })
                    this.props.handleClose()
                }
            });
        }

    }
    modifyPwd = async ()=>{
        try {
            const values = await this.refs.modifyPwdForm.validateFields();
            // console.log('Success:', values);
            if(values.newpwdagain !== values.newpwd){
                aisinoInfoModal(commonLan.passwordIsDifferentFromNewPassword);
                return;
            }
            if(values.oldpwd ===values.newpwd){
                aisinoInfoModal(commonLan.newPasswordCanTSetTheSameAsTheOriginalOne);
                return;
            }
            const that = this;
            aisinoConfirmModal(commonLan.submitConfirm.label,"",()=>{
                post('aisino/invoiceModifyPwd/modifySelfPwd',{
                    oldpwd:values.oldpwd,
                    cpwd:values.newpwd,
                    newpwd:values.newpwdagain,
                }).then(response =>{
                   if(response == true){
                       aisinoInfoModal(loginLan.passwordSuccessfullyChangedPleaseReLogin,()=>{
                           that.refs.modifyPwdForm.resetFields();
                           post('aos/mainui/index/logout',{})
                               .then(response=>{
                                   if(response === null) return;
                                    this.refs.modifyPwdForm.setFieldsValue({
                                        oldpwd:"",
                                        newpwd:"",
                                        newpwdagain:"",
                                    })
                                   getCachingKeys().forEach(item => {
                                       dropByCacheKey(item)
                                   })
                                   cookie.remove(LOGIN);
                                   cookie.remove(USER_ID);
                                   cookie.remove(LEGAL_NAME);
                                   cookie.remove("gridPageSizeParam");
                                   cookie.remove("gridSizeListParam");
                                   if(this.props.login){
                                    postSync('aos/rms/pwd/modifyUserSessionInfo',{'modifytype':this.props.modifytype}).then(response=>{
                                                getCachingKeys().forEach(item => {
                                                    dropByCacheKey(item)
                                                })
                                                this.refs.modifyPwdForm.setFieldsValue({
                                                    oldpwd:"",
                                                    newpwd:"",
                                                    newpwdagain:"",
                                                })
                                                cookie.remove(LOGIN);
                                                cookie.remove(USER_ID);
                                                cookie.remove(LEGAL_NAME);
                                                cookie.remove("gridPageSizeParam");
                                                cookie.remove("gridSizeListParam");
                                                store.dispatch(logout());
                                                this.props.handleClose(false)
                                        });
                                   }
                                //    if(!isEmpty(that.state.callbackFun)){
                                //        that.state.callbackFun(response);
                                //    }
                                    this.props.handleClose()
                                    this.props.history.push('/login');
                                    store.dispatch(logout());
                               })
                       });
                   }
                });
            })
        } catch (errorInfo) {
            // console.log('Failed:', errorInfo);
        }
    }
    render() {
        const buttonModules=[
            <AisinoButton type="primary" icon={<CheckSquareOutlined/>} onClick={this.modifyPwd} >{commonLan.submitButton.label}</AisinoButton>,
            <AisinoButton htmlType="button" icon={<CloseSquareOutlined/>} onClick={this.close}>{commonLan.cancelButton.label}</AisinoButton>,
        ];
        return (
            <AisinoForm {...formLayout} validateMessages={validateMessages()}
                        name="modifyPwd-ref" ref="modifyPwdForm" >
                <AisinoFormItem label={loginLan.oldPassword} name={"oldpwd"} rules={[{required: true},{max:100}]} >
                    <AisinoPassword />
                </AisinoFormItem>
                <AisinoFormItem label={loginLan.newPassword} name={"newpwd"} rules={[{required: true},{max:100},
                    ({getFieldValue}) => ({
                        validator(rule, value) {
                            if(value){
                                let res = pwdCheck(value);
                                if(res === 3){
                                    return  Promise.reject(commonLan.pwdIncorrect);
                                }
                                else if(res === 1){
                                    return  Promise.reject(commonLan.pwdHasSpecialCharacter);
                                }
                                else{
                                    return Promise.resolve();
                                }
                            }
                            return Promise.resolve();
                        },
                    })]}>
                    <AisinoPassword /></AisinoFormItem>
                <AisinoFormItem label={loginLan.confirmPassword} name={"newpwdagain"} rules={[{required: true},{max:100}]}>
                    <AisinoPassword /></AisinoFormItem>
                <div style={{margin:"10px 0px 15px 0px",fontSize:"8pt",}}>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{commonLan.pwdFormatIncorrect}{commonLan.pwdHasSpecialCharacter2}
                </div>
                <div className="pageBottomButtonBg">
                    <AisinoButtonArea buttonModules={buttonModules} style={{justifyContent: "center"}}/>
                </div>
            </AisinoForm>
        );
    }
}
export default ModifyPassword;
